// extracted by mini-css-extract-plugin
module.exports = {"symbol__text":"Symbol_symbol__text__etmRY","symbol":"Symbol_symbol__3F3sf"};